import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export const LegalLayout = ({ title, description, updated = "June 2026", testId, children }) => {
  const { pathname } = useLocation();
  return (
  <main className="bg-white" data-testid={testId}>
    <Helmet>
      <title>{`${title} | VoiceRanker.ai`}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`https://voiceranker.ai${pathname}`} />
    </Helmet>
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-3">Legal</p>
      <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tight text-[#0F172A]">{title}</h1>
      <p className="mt-3 text-sm text-slate-500">Last updated: {updated}</p>
      <div className="prose prose-slate max-w-none mt-10 prose-headings:font-heading prose-headings:tracking-tight prose-headings:text-[#0F172A] prose-a:text-[#1A56DB]">
        {children}
      </div>
    </div>
  </main>
  );
};
